// Wizard entry — lives on the new-project template picker. Gives the
// onboarding wizard a "show me alternatives" escape hatch so users aren't
// locked into the default 3-card template menu. Minimal-stub onApply
// toasts the picked headline; Workstream D ships the real wizard-state
// hook (setTemplateBlock).

import { useStudioLocale } from '@/i18n'
import { BrainstormCta } from './brainstorm-cta'

export function WizardBrainstormCta({ pattern, dsId }: { pattern?: string; dsId?: string }) {
  const copy = useStudioLocale().strings.newProject.step2Template
  return (
    <BrainstormCta
      entry="wizard"
      label={copy.exploreMore}
      pattern={pattern}
      dsId={dsId}
    />
  )
}
